export enum eOrderGroupCategory {
  Mobility = 'MOBILITY',
  Bulk = 'BULK',
}

export const DisplayOrderGroupCategory = {
  [eOrderGroupCategory.Mobility]: 'Mobility',
  [eOrderGroupCategory.Bulk]: 'Bulk',
};
